import React, { FC, useState } from "react";
import GeneralData from "./Tabs/GeneralData";
import Passport from "./Tabs/Passport";
import BirthAndLanguage from "./Tabs/BirthAndLanguage";
import ChangesFio from "./Tabs/ChangesFio";
import Vaccination from "./Tabs/Vaccination";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";

const generalTabs = [
  {
    title: "Основные данные",
    component: <GeneralData />,
  },
  {
    title: "Паспорт, адрес",
    component: <Passport />,
  },
  {
    title: "Место рождения, знание языка",
    component: <BirthAndLanguage />,
  },
  {
    title: "ФИО до изменения",
    component: <ChangesFio />,
  },
  {
    title: "Вакцинация / ревакцинация",
    component: <Vaccination />,
  },
];

const General: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {generalTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {generalTabs[tab].component}
    </Wrapper>
  );
};

export default General;
